module.exports = __webpack_public_path__ + "fonts/d948a2faa0fa44ade23b7632584e4502.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/driver.svg
// module id = 2046
// module chunks = 0